export default __webpack_public_path__ + "static/media/av.9e451b14.jpg";